<template>
  <div>
    <!-- 提出赔款 -->
    <el-dialog :title="$t('message.billOfIndemnity') + ':' + reparation_sn + `  状态：( ${type})`"
      :close-on-click-modal="false" :visible.sync="dialogVisible" width="1800px" center>
      <!-- 赔款原因 -->
      <div class="reason">
        <div class="label">{{ $t('message.reasonForCompensation') }}:</div>
        <div class="text">
          <el-input v-model="reason" type="textarea"></el-input>
        </div>
      </div>
      <!-- 列表 -->
      <div class="reason">
        <div class="label">{{ $t('message.pic') }}:</div>
        <div class="text">
          <el-upload :action="baseURL + '/api/common/uploadFile'" list-type="picture-card"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="fileList"
            :on-success="successup">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
      <div class="content">
        <div class="table">
          <ol>
            <!--  番号-->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!--  订单号-->
            <li>{{ $t("message.orderNumber") }}</li>
            <!--  图片-->
            <li>{{ $t("message.pic") }}</li>
            <!--  商品属性-->
            <li>{{ $t("message.commodityAttribute") }}</li>
            <!--  附加服务-->
            <li>{{ $t("message.additionalServices") }}</li>
            <!--  商品数-->
            <li>{{ $t("message.numberOfGoods") }}</li>
            <!--  单价（元）-->
            <li class="flex05">{{ $t("message.priceYuan") }}</li>
            <!--实际赔款-->
            <!-- <li>{{ $t("message.actualCompensation") }}元</li> -->
          </ol>
          <!-- 列表详情 -->
          <div class="table_detail">
            <!-- 列表 -->
            <ul v-for="(items, indexs) in indemnityList" :key="indexs">
              <!--  番号-->
              <li class="flex05">{{ items.sorting }}</li>
              <!--  订单号-->
              <li>{{ items.order_sn }}</li>
              <!--  图片-->
              <li>
                <el-popover placement="right" width="300" trigger="hover">
                  <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                  <a :href="`https://detail.1688.com/offer/${items.goods_id}.html`" target="_blank" slot="reference">
                    <img :src="items.pic" alt="" style="width: 60px; height: 60px" />
                  </a>
                </el-popover>
              </li>
              <!--  商品属性-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in items.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  附加服务-->
              <li>
                <div class="attribute">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 80px">
                      <div class="row" v-for="(opti, optiIndex) in items.option" :key="optiIndex">
                        <p v-if="opti.num > 0">
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price
                          }}元</span>
                          <span v-else> {{ opti.price }}% </span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!--  商品数-->
              <li>
                <div class="attribute">
                  <!-- 购买数 -->
                  <p>
                    {{ $t("message.purchaseNumber") }}:{{ items.confirm_num }}
                  </p>
                  <!-- 发送数 -->
                  <p>
                    {{ $t("message.numberOfTransmissions") }}:{{ items.fasong_num }}
                  </p>
                </div>
              </li>
              <!--  单价（元）-->
              <li class="flex05">{{ items.confirm_price }}</li>
              <!--实际赔款-->
              <!-- <li><el-input v-model="items.amount" @input="totalIndemnity" type="number"
                  onfocus="this.select()"></el-input>
              </li> -->
            </ul>
          </div>
        </div>
        <!-- add -->
        <div class="add">
          <el-button type="success" size="mini" @click="add" v-if="type != '已确认' && isAuth(346)">{{ $t('message.add')
            }}</el-button>
        </div>
        <!-- 赔款人 -->
        <div class="indemnity_details">
          <!-- 主责任人 -->
          <div class="responsible_box">
            <div class="responsible_person">
              <!-- 赔款类别 -->
              <div class="row">
                <div class="label">
                  {{ $t('message.compensationCategory') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_reason" size="mini" placeholder="请选择">
                    <el-option v-for="item in reparationReasonList" :label="item" :value="item" :key="item">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 赔款数量:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.amountOfIndemnity') }}:
                </div>
                <div class="val"><el-input v-model="reparation_num" size="mini" @blur="getReparationsByUser"></el-input>
                </div>
              </div>
              <!-- 赔款类型:： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.reparationType') }}:
                </div>
                <div class="val">
                  <el-select filterable v-model="reparation_type" size="mini" @change="getReparationsByUser"
                    placeholder="请选择">
                    <el-option v-for="item in reparationType" :label="item.value" :value="item.value" :key="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- 责任人类别： -->
              <div class="row">
                <div class="label">
                  {{ $t('message.categoryOfResponsiblePerson') }}:
                </div>
                <div class="val">
                  <!-- 公司员工 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="1" @change="changeRadio">
                        {{ $t('message.companyEmployee') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select v-model="liable_content" placeholder="请选择" size="small" @change="changeAdmin"
                        filterable>
                        <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <!-- 外部物流公司 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="2" @change="changeRadio">
                        {{ $t('message.externalLogisticsCompany') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-select filterable v-model="wuliuName"
                        :placeholder="$t('message.pleaseEnterTheLogisticsNumber')" size="mini"
                        @change="otherResponsibility">
                        <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
                        </el-option>
                      </el-select>
                      <!-- <el-input v-model="wuliuName" size="small" @input="otherResponsibility"></el-input> -->
                    </div>
                  </div>
                  <!-- 第三方卖家 -->
                  <div class="item">
                    <div class=" radio">
                      <el-radio v-model="liable_type" label="3" @change="changeRadio">
                        {{ $t('message.thirdPartySeller') }}
                      </el-radio>
                    </div>
                    <div class="input">
                      <el-input v-model="thirdParty" size="small" @input="otherResponsibility"></el-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 承担费用明细 -->
          <div class="expenses_details">
            <div class="total">
              <div class="item"> 理应赔款金额：<el-input v-model="should_amount"></el-input> 元</div>
              <div class="item">
                实际赔款金额：<el-input v-model="actual_amount"></el-input>元
              </div>
              <div class="item">团队赔款：<el-input v-model="team_amount" type="number" min="0"
                  step="0.01" @input="teamAmountEdited = true"></el-input>元</div>
            </div>
            <div class="table">
              <ol>
                <!-- 承担费用明细 -->
                <li>{{ $t('message.detailsOfExpensesBorne') }}</li>
                <!-- 责任人选择 -->
                <li>{{ $t('message.responsiblePersonSelection') }}</li>
                <!-- 责任人角色 -->
                <li>{{ $t('message.responsiblePersonRole') }}</li>
                <!-- 承担金额（元） -->
                <li>{{ $t('message.bearingRatio') }}（元）</li>
                <!-- 操作 -->
                <li class="flex05">{{ $t('message.operation') }}</li>
              </ol>
              <!-- 关联责任人 -->
              <ul v-for="(item, index) in reparationList" :key="index">
                <!-- 承担费用明细 -->
                <li>
                  <span v-if="item.type == 2"> {{ $t('message.associatedResponsiblePerson') }} {{ index }}</span>
                  <span v-else> 主责任人</span>
                </li>
                <!-- 责任承担人 -->
                <li>
                  <span v-if="item.type == 3 || item.main == '公司'">
                    {{ item.main }}
                  </span>
                  <el-select v-model="item.main" placeholder="请选择" size="small" @change="changeName($event, index)"
                    filterable v-else>
                    <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <!-- 责任人角色 -->
                <li>{{ item.name }}</li>
                <!-- 承担金额（元） -->
                <li> <input type="text" v-model="item.amount" onfocus="this.select()" @input="actual_amount_total"></li>
                <!-- 操作 -->
                <li class="flex05">
                  <el-button type="danger" class="dark" size="mini" @click="del(index)" v-if="type != '已确认'">
                    {{ $t('message.delete') }}
                  </el-button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="type == '未提出'">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}</el-button>
        <!-- 赔款单-添加 -->
        <el-button type="primary" @click="storeReparation" v-if="isAuth(346)">
          {{ $t("message.billOfIndemnityAdded") }}
        </el-button>
      </span>
      <!-- 查看操作 -->
      <div class="operation" v-else-if="type != '已确认'">
        <!-- 删除 -->
        <el-button size="small" type="primary" class="dark" @click="deleteReparation" v-if="isAuth(345)">
          {{ $t("message.delete") }}
        </el-button>
        <!-- 修改 -->
        <el-button size="small" type="primary" @click="updateReparation" v-if="isAuth(342)">
          {{ $t("message.edit") }}
        </el-button>

        <!-- 保存 -->
        <!-- <el-button size="small" type="primary">{{ $t("message.save")
        }}</el-button> -->
        <!-- 赔款确认 -->
        <el-button size="small" type="primary" @click="confirmReparation" v-if="isAuth(343)">
          {{ $t("message.confirmationOfClaims") }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 查看大图 -->
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>

import { mapState } from 'vuex'
import { reparationType } from '@/utlis/options'
export default {
  props: {
    indemnityList: { type: Array },
    reparation_sn: { type: String },
    type: { type: String },
  },
  data() {
    return {
      reparationType,
      dialogVisible: false,
      detail: {}, //详情
      liable_type: '', //责任人类别
      liable_content: '',//责任主体内容
      liable_name: '', //责任人名称
      wuliuName: '', //物流填写
      thirdParty: '',//第三方卖家
      shouldTotal: 0,//理应赔款
      reparation_num: 0, //赔款数量
      reparation_type: '默认', // 赔款类型
      reparationList: [], //关联责任人
      responsiblePersonData: {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
        should_amount: 0,
      },

      reason: '',
      adminList: [],
      fileList: [],
      imgDialogVisible: false,
      dialogImageUrl: '',
      reparationReasonList: [],//赔款类别选项
      reparation_reason: '',//赔款类别
      should_amount: 0,//赔款单总理应赔款
      actual_amount: 0,//赔款单总实际赔款
      team_amount: 0,//团队赔款
      teamAmountEdited: false,//人工修改后不再跟随理应赔款
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,

    }),
  },
  created() {
    // 获取赔款人
    this.$api.roleApi.accountNumberList({ pageSize: 99999, forSelect: 1 }).then(res => {
      this.adminList = res.data.data
    })
    this.reparationReason()

  },
  methods: {
    // 获取赔款类型选项
    reparationReason(liable_content = '', keepSelected = false) {
      const reparation_reason = this.reparation_reason
      if (!keepSelected) {
        this.reparation_reason = ''
      }
      this.$api.capitalApi
        .reparationReason({ liable_content }).then(res => {
          this.reparationReasonList = Array.isArray(res.data) ? res.data : []
          if (keepSelected) {
            this.reparation_reason = reparation_reason
          }
          this.$forceUpdate()
        })
    },
    getReparationReasonLiableContent() {
      if (this.liable_type == 1) return this.liable_content
      if (this.liable_type == 2) return this.wuliuName
      if (this.liable_type == 3) return this.thirdParty
      return ''
    },
    validateReparationReason() {
      if (this.reparationReasonList.length && !this.reparation_reason) {
        this.$message.error('赔款类别未选择')
        return false
      }
      return true
    },
    // 根据理应赔款计算金额
    getReparationsByUser() {

      let datas = {
        userName: this.responsiblePersonData.main_admin,
        shouleMoney: this.should_amount,
        type: this.reparation_type,
        numbers: this.reparation_num
      }
      if (datas.userName == '' || datas.type == '' || datas.numbers === '') {
        return false
      }
      this.reparationList = []
      this.$api.capitalApi.getReparationsByUser(datas).then((res) => {
        if (res.errcode == 1) return false
        res.data.peikuan.forEach(item => {
          let nameData = this.adminList.find(items => items.realname == item.name)
          if (item.name == '公司') {
            this.reparationList.push({
              main: item.name,
              rate: 1,
              amount: item.amount,
              type: '2',
              name: item.name,
              should_amount: 0,
            })
          } else {
            this.reparationList.push({
              main: nameData.id,
              rate: 1,
              amount: item.amount,
              type: nameData.realname == datas.userName ? '1' : '2',
              name: nameData.role[0].name,
              should_amount: nameData.realname == datas.userName ? this.shouldTotal : 0,
            })
          }
        })
        this.actual_amount_total()

      })
    },
    // 售后-赔款单-添加
    storeReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
        liable_type: this.liable_type,
        liable_content: '',
        reason: this.reason,
        orderDetailSet: [],
        reparationList: JSON.parse(JSON.stringify(this.reparationList)),
        reparation_num: this.reparation_num,
        reparation_type: this.reparation_type,
        reparation_reason: this.reparation_reason,
        images: [],
        should_amount: this.should_amount,
        actual_amount: this.actual_amount,
        team_amount: this.team_amount,
      }
      this.fileList.forEach(item => {
        datas.images.push(item.response.data)
      })
      // 责任主体内容(责任人ID,物流号,卖家ID)
      if (this.liable_type == 1) {
        datas.liable_content = this.liable_content
      } else if (this.liable_type == 2) {
        datas.liable_content = this.wuliuName
      } else if (this.liable_type == 3) {
        datas.liable_content = this.thirdParty
      }
      // 售后详情id 售后详情赔款比例
      this.indemnityList.forEach(item => {
        datas.orderDetailSet.push({
          id: item.id,
          rate: 100,
          amount: item.amount
        })
      })
      //  if (datas.reparation_reason == '') return this.$message.error('赔款类别未选择')
      if (!this.validateReparationReason()) return
      this.$api.capitalApi.storeReparation(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.reparationList()
      })
    },

    //新增
    add() {
      this.reparationList.push({
        main: '',
        rate: 1,
        amount: 0,
        type: '2',
        name: '',
        should_amount: 0,
      })
      // console.log(this.adminList);
    },
    // 删除
    del(i) {
      this.reparationList.splice(i, 1)
    },
    //责任人类别:选择
    changeRadio(e) {
      if (e == 1) {

        this.getReparationsByUser()
      } else if (e == 2) {
        this.reparationList = []
        this.reparationList.push({
          main: this.wuliuName,
          rate: 1,
          amount: this.shouldTotal,
          type: '3',
          name: this.wuliuName,
          should_amount: this.shouldTotal,
        })
      } else if (e == 3) {
        this.reparationList = []
        this.reparationList.push({
          main: this.thirdParty,
          rate: 1,
          amount: this.shouldTotal,
          type: '3',
          name: this.thirdParty,
          should_amount: this.shouldTotal,
        })
      }

      this.$forceUpdate()

    },
    //选择主责任人
    changeAdmin(e) {
      let item = this.adminList.find(item => item.id == e)
      if (item.role == false) return this.$message('未找到角色')

      this.responsiblePersonData.roleName = item.role[0].name
      this.liable_name = item.realname
      if (this.liable_type == 1) {
        this.responsiblePersonData.main = e
        this.responsiblePersonData.main_admin = this.liable_name
        this.getReparationsByUser()
        this.reparationReason(e)
      }
    },
    // 选择其他责任类别
    otherResponsibility() {
      if (this.liable_type == 2) {
        this.reparationList[0].name = this.wuliuName
        this.reparationList[0].main = this.wuliuName
      } else if (this.liable_type == 3) {
        this.reparationList[0].name = this.thirdParty ? this.thirdParty : '第三方买家'
        this.reparationList[0].main = this.thirdParty ? this.thirdParty : '第三方买家'

      }
    },
    // 关联责任人选择
    changeName(e, i) {



      let role = this.adminList.find(item => item.id == e).role
      if (role != false) {
        this.reparationList[i].name = role[0].name
      } else {
        this.reparationList[i].name = ''
      }
    },
    //计算总计赔款金额
    totalIndemnity() {
      let goodsAmount = 0
      let businessAmount = 0
      let hasGoodsPrice = false
      this.indemnityList.forEach(item => {
        const quantity = Number(item.confirm_num)
        const price = Number(item.confirm_price)
        if (item.confirm_num !== '' && item.confirm_num != null && item.confirm_price !== '' &&
          item.confirm_price != null && Number.isFinite(quantity) && Number.isFinite(price)) {
          hasGoodsPrice = true
          goodsAmount += quantity * price
        }
        businessAmount += Number(item.amount || 0)
      })
      // 有数量和单价时取“数量×单价”和业务赔款总额中的较大值，否则取业务赔款总额。
      this.should_amount = (hasGoodsPrice ? Math.max(goodsAmount, businessAmount) : businessAmount).toFixed(2)
      this.$forceUpdate()
    },
    //新增 赔款单数据
    addIndemnity() {
      this.liable_type = '' //责任人类别
      this.liable_content = ''//责任主体内容
      this.liable_name = '' //责任人名称
      this.fileList = []
      this.wuliuName = '' //物流填写
      this.thirdParty = ''//第三方卖家
      this.reason = ''// 赔款原因
      this.shouldTotal = 0 //理应赔款
      this.reparation_num = 0 //赔款数量
      this.reparation_type = '默认' // 赔款类型
      this.reparation_reason = ''
      this.reparationList = [] //关联责任人
      this.actual_amount = 0
      this.team_amount = 0
      this.teamAmountEdited = false
      this.responsiblePersonData = {
        type: '1',
        main: '',
        rate: 0,
        amount: 0,
        name: '',
      }
      this.totalIndemnity()
      this.reparationReason()
      this.dialogVisible = true


    },
    //修改赔款单数据
    editIndemnity(data) {

      this.wuliuName = '' //物流填写
      this.thirdParty = ''//第三方卖家
      this.liable_content = ''
      this.reparation_num = data.reparation_num
      this.reason = data.reason
      this.reparation_type = data.reparation_type
      this.reparation_reason = data.reparation_reason
      this.reparationList = []
      this.liable_type = data.liable_type + ''//责任人类别
      this.should_amount = data.should_amount
      this.actual_amount = data.actual_amount
      this.team_amount = data.team_amount == null ? '' : data.team_amount
      this.teamAmountEdited = true
      data.reparation_amount.forEach((item, index) => {
        // 责任人类别
        if (this.liable_type == 1 && index == 0) {
          this.liable_content = item.main - 0

        } else if (this.liable_type == 2 && index == 0) {
          this.wuliuName = item.main
        } else if (this.liable_type == 3 && index == 0) {
          this.thirdParty = item.main
        }
        this.reparationList.push(item)
        if (item.type == 1) {
          this.responsiblePersonData = item
        }
        if ((item.type == 1 || item.type == 2) && item.main != '公司') {
          item.main = item.main - 0
        }
      })
      this.fileList = []
      data.images.forEach(item => {
        this.fileList.push({
          url: item
        })
      })
      // // 查找组织
      this.reparationList.forEach((item, index) => {
        if (item.type != 3 && item.main != '公司') {
          this.changeName(item.main, index)

        }
      })
      this.reparationReason(this.getReparationReasonLiableContent(), true)
      this.dialogVisible = true

      this.$forceUpdate()
    },
    //删除赔款单单
    deleteReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
      };
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.capitalApi.deleteReparation(datas).then((res) => {
            this.$message.success(res.msg)
            this.$parent.reparationList()
            this.dialogVisible = false
          });
        })
        .catch(() => { });
    },
    //售后-赔款单-确认
    confirmReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
      };
      this.$confirm(
        '是否确认赔款确认？',
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.capitalApi.confirmReparation(datas).then((res) => {
            this.$message.success(res.msg)
            this.$parent.reparationList()
            this.dialogVisible = false
          });
        })
        .catch(() => { });
    },
    //售后-赔款单-修改
    updateReparation() {
      let datas = {
        reparation_sn: this.reparation_sn,
        liable_type: this.liable_type,
        liable_content: '',
        reason: this.reason,
        orderDetailSet: [],
        reparationList: JSON.parse(JSON.stringify(this.reparationList)),
        reparation_num: this.reparation_num,
        reparation_type: this.reparation_type,
        reparation_reason: this.reparation_reason,
        images: [],
        should_amount: this.should_amount,
        actual_amount: this.actual_amount,
        team_amount: this.team_amount,
      }
      this.fileList.forEach(item => {
        if (item.response) {
          datas.images.push(item.response.data)
        } else {
          datas.images.push(item.url)
        }
      })
      // 责任主体内容(责任人ID,物流号,卖家ID)
      if (this.liable_type == 1) {
        datas.liable_content = this.liable_content
      } else if (this.liable_type == 2) {
        datas.liable_content = this.wuliuName
      } else if (this.liable_type == 3) {
        datas.liable_content = this.thirdParty
      }
      // 售后详情id 售后详情赔款比例
      this.indemnityList.forEach(item => {
        datas.orderDetailSet.push({
          id: item.id,
          rate: 100,
          amount: item.amount
        })
      })
      //  if (datas.reparation_reason == '') return this.$message.error('赔款类别未选择')
      if (!this.validateReparationReason()) return
      this.$api.capitalApi.updateReparation(datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.reparationList()
      })
    },

    // 图片上传成功事件
    successup(res, file, fileList) {
      this.fileList = fileList
      this.$forceUpdate()
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    //实际赔款金额
    actual_amount_total() {
      this.actual_amount = 0
      this.team_amount =0
      this.reparationList.forEach(item => {
        this.actual_amount += item.amount - 0
        this.team_amount += item.amount - 0
      })
    },
  },

};
</script>
<style lang='scss' scoped>
/deep/.el-radio__inner {
  transform: scale(1.5) !important;
}

/deep/.el-textarea__inner {
  height: 100px;
}

.head {
  padding: 0 24px;
  height: 56px;
  line-height: 56px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  margin-bottom: 16px;
  display: flex;
  position: relative;
  font-size: 14px;

  .item {
    margin-right: 60px;
  }

  .el-button {
    position: absolute;
    top: 8px;
    right: 24px;
  }
}

.reason {
  display: flex;
  margin-bottom: 24px;

  .label {
    width: 100px;
  }

  .text {
    flex: 1;
    margin-left: 20px;
  }
}

.imgList {
  margin-bottom: 30px;
}

.content {
  padding: 16px 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;



  .table_detail {
    .detail_head {
      display: flex;
      font-size: 14px;
      height: 60px;
      background: #545467;
      border-radius: 4px;
      color: #fff;
      margin-top: 20px;

      .order {
        display: flex;
        align-items: center;
        padding-left: 16px;
      }

      .item {
        margin-left: 60px;
        line-height: 60px;
      }
    }
  }



  .table {
    font-size: 12px;
    max-height: 450px;
    overflow-y: auto;

    ol {
      display: flex;
      position: sticky;
      top: 0;
      left: 0;
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
        position: relative;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }

    .attribute {
      width: 100%;
      text-align: center;
      max-height: 100px;
      overflow: hidden;

      .el-button {
        position: absolute;
        top: 5px;
        right: 10px;
      }
    }

    .imgList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .imgs {
        width: 40px;
        height: 40px;
        margin: 0px 0px 10px 10px;

        .el-image {
          width: 40px;
          height: 40px;
          border: 1px dashed #ccc;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          border-radius: 3px;
          cursor: pointer;
        }
      }
    }

    .radio {
      flex: 9;
      width: 100%;
      justify-content: flex-start;

      span {
        margin: 0 40px 0 13px;
      }
    }
  }

  .add {
    text-align: right;
    margin-top: 20px;
  }

  .indemnity_details {
    display: flex;
    margin-top: 24px;

    .responsible_box {
      .responsible_person {
        border: 2px solid #32323C;

        .row {
          border-bottom: 1px solid #32323C;



          &:nth-last-child(1) {
            border: 0
          }

          display: flex;

          .label {
            width: 150px;
            border-right: 1px solid #32323C;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 14px 0;
          }

          .val {
            flex: 1;
            padding: 14px 30px;

            .item {
              display: flex;
              line-height: 40px;

              .radio {
                width: 120px;
                margin-right: 10px;

              }

              .input {
                width: 180px;

                /deep/.el-select {
                  width: 100%;

                  .el-input__inner {
                    height: 32px;
                  }

                }

                /deep/.el-input {
                  width: 100%;
                }
              }
            }
          }
        }
      }
    }


    .expenses_details {
      width: 1120px;
      margin-left: 50px;

      .total {
        display: flex;
        margin-bottom: 10px;

        .item {
          flex: 1;
          font-size: 16px;
          font-weight: bold;
          display: flex;
          line-height: 40px;

          /deep/.el-input {
            width: 100px;
            margin: 0 10px;
          }
        }
      }

      input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 38px;
        width: 70%;
        padding: 0 10px;
      }

      ul {
        li {
          &:nth-child(1) {
            background-color: #fff;
          }
        }
      }
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-textarea__inner {
    width: 90%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}

.operation {
  margin-top: 24px;
  text-align: right;
}
</style>
